export default defineNuxtRouteMiddleware(() => {
  if (!import.meta.client) return

  const { protocol, hostname, href } = window.location
  const isLocalhost = ['localhost', '127.0.0.1', '0.0.0.0', '::1'].includes(hostname)

  if (protocol === 'http:' && !isLocalhost) {
    window.location.replace(href.replace(/^http:/, 'https:'))
  }
})
